import routerOptions0 from "/home/viva/source/techedu/frontvue/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@vue+compiler-sfc@3.5.44_cac@6.7.14_db0@0.3.4_e_ed6b8f5ecee971df2d373d33aadc32cf/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/viva/source/techedu/frontvue/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}